"use client"
/* */
const slider = "flow--slider";
const text = "flow--slider--text";
const value = "flow--slider--value";
const track = "flow--slider--track";
const fill = "flow--slider--fill";
const initialMarker = "flow--slider--initial-marker";
const handle = "flow--slider--handle";
const increment = "flow--slider--increment";
const decrement = "flow--slider--decrement";
const disabled = "flow--slider--disabled";
const styles = {
	slider: slider,
	text: text,
	value: value,
	track: track,
	fill: fill,
	initialMarker: initialMarker,
	handle: handle,
	increment: increment,
	decrement: decrement,
	disabled: disabled
};

export { decrement, styles as default, disabled, fill, handle, increment, initialMarker, slider, text, track, value };
//# sourceMappingURL=Slider.module.scss.mjs.map
